import { Component, OnInit } from '@angular/core';
import { environment } from '@environment';
import { PowerBIEmbedModule } from "powerbi-client-angular";
import { BaseComponent } from '../base/base.component';
import { ReportAccess } from '@models/report-access';
import { firstValueFrom } from 'rxjs';
import { ReportService } from '@services/report.service';
import { IReportEmbedConfiguration } from 'embed';
import { models } from 'powerbi-client';
import { UserService } from '@services/user.service';
import { ReportSummary } from '@models/report-summary';
import { ReportParameter } from '@models/report-parameter';

@Component({
  selector: 'cp-report',
  imports: [PowerBIEmbedModule],
  templateUrl: './report.component.html',
  styleUrl: './report.component.less',
})
export class ReportComponent extends BaseComponent implements OnInit {
    reportReady: boolean = false;
    reportId: string = '';
    // reportSummary: ReportSummary;

    public reportConfig: IReportEmbedConfiguration = {
        type: 'report',
        embedUrl: undefined,
        id: undefined,
        tokenType: models.TokenType.Embed,
        accessToken: undefined,
        settings: {
            // panes: {
            //     filters: {
            //         expanded: false,
            //         visible: false
            //     },
            // },
            background: models.BackgroundType.Transparent,
        }
    };

    powerBiClass = 'report-container';

    powerBIPhasedEmbedding = false;

    powerBiEventHandlers = new Map([
        ['loaded', () => console.log('Report loaded')],
        ['rendered', () => console.log('Report rendered')],
        ['error', (event) => {
            console.log('Report error:' + event.detail.detailedMessage);
            }
        ]
    ]);

    get isBMSTestEnv(): boolean {
        return environment.System === 'BMS' && !environment.production;
    }

    constructor(
        private _userService: UserService,
        // private _languageSyncService: LanguageSyncService,
        private _reportService: ReportService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        await this.initialize();
    }

    async initialize(): Promise<void> {
        let reportAccess: ReportAccess =
            await firstValueFrom(this._reportService.getReportAccess(this.reportId)).then();

        let reportSummary: ReportSummary =
            await firstValueFrom(this._reportService.getReportList(`${this.reportId}`))
                .then((reports: ReportSummary[]) => reports[0]);

        this.reportConfig.embedUrl = reportAccess.Url;
        this.reportConfig.accessToken = reportAccess.Token;
        this.reportConfig.id = reportSummary.Id;

        if (reportSummary.Parameters && reportSummary.Parameters.length > 0) {
            let filters: models.IBasicFilter[] = [];
            reportSummary.Parameters.forEach((param: ReportParameter) => {
                const reportFilter: models.IBasicFilter = this.getFilterForReport(param);
                if (reportFilter) {
                    filters.push(reportFilter);
                }
            });
            if (filters.length > 0) {
                this.reportConfig.filters = filters;
            }
        }

        this.reportReady = true;
    }

    private getFilterForReport(param: ReportParameter): models.IBasicFilter {
        if (!param) {
            return null;
        }

        let value: string = '';
        if (param.Value.length > 0) {
            switch(param.Value) {
                case '$CurrentAccount':
                    value = this._userService.getCustomerAccount().AccountNumber;
                    break;
                case '$CurrentUserName':
                    value = this._userService.getCurrentUser().Name;
                    break;
                case '$CurrentUserId':
                    value = this._userService.getCurrentUser().UserId;
                    break;
                default:
                    value = param.Value;
            }
        }

        let filter: models.IBasicFilter = {
            filterType: models.FilterType.Basic,
            $schema: "http://powerbi.com/product/schema#basic", // Filter schema
            target: {
                table: param.Table,
                column: param.Column
            },
            operator: "In", // Filter operator
            values: [value] // Value to filter by
        }

        return filter;
    }
}
